import { emailLink } from '@ps/web-core-utils';
import type { ReactNode } from 'react';

import StarsLink from '../StarsLink/StarsLink';

export const starsEmailLink = (text: ReactNode) => emailLink(text as string, StarsLink);
